import { flatten, map, pipe, prop, take, uniq } from 'ramda';
import { useEffectOnce } from 'js/hooks/useEffectOnce';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { usePortletDispatch, usePortletSelector } from 'js/components/system/Portlet';
import { setImagesLoadedAction } from './actions';

export const getImagePromise = src => new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = resolve;
    image.onerror = reject;
    image.src = src;
});

export const loadImages = ({ games, categories, isLoggedIn, dispatch }) => {
    const promises = pipe(
        map(pipe(
            prop('gameCodes'),
            take(6) // take only first 6 games from each category
        )),
        flatten,
        uniq,
        map((gameCode) => {
            const { images: { base, guest } } = games[gameCode];
            return !isLoggedIn && guest || base;
        }),
        map(getImagePromise)
    )(categories);

    return Promise.all(promises)
        .catch(e => console.error(`failed to load ${e.target.src}`))
        .finally(() => dispatch(setImagesLoadedAction()));
};

export const useLoadImages = () => {
    const games = useAppSelector(prop('games'));
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const categories = usePortletSelector(prop('categories'));
    const dispatch = usePortletDispatch();

    useEffectOnce(
        () => {
            loadImages({ games, categories, isLoggedIn, dispatch });
        },
        [games, categories, isLoggedIn, dispatch],
        () => categories.length > 0
    );
};
